import { toSafeString } from '@shared/utils';
import upsertThreadContentItem from '@/lib/threads/upsertThreadContentItem.js';
import mapPublicShareItemsToActivity from '@/lib/threadEvents/mapPublicShareItemsToActivity.js';
import buildThreadContentShell from '@/redux/reducers/pieveReducer/buildThreadContentShell.js';

const mapPublicThreadToRegularThread = ({ state, data }) => {
  const threadId = toSafeString(data?.threadId);

  if (!threadId) {
    return state;
  }

  const activity = mapPublicShareItemsToActivity(data?.items);
  const shell = buildThreadContentShell({ threadId, activity, runState: { state: 'idle', runId: null } });

  if (shell) {
    shell.header.title = toSafeString(data?.title) || 'Shared task';
  }

  return {
    ...state,
    publicThread: data || null,
    threadContent: shell ? upsertThreadContentItem(state?.threadContent, shell) : state?.threadContent
  };
};

export default mapPublicThreadToRegularThread;
